import React from 'react'

import collectButtonTexture from '@assets/button-gamble-small-enabled.svg'
import collectButtonTextureEQ from '@assets/jackpot-eq/button-gamble-small-enabled-eq.svg'

import { SideButton } from '../'
import { GambleClickedMessage, GameUIMessageType } from 'game-ui-types'
import { useSpinButtonSectionStore } from '@stores/spinButtonSectionStore'
import { useJackpotStore } from '@stores'

interface GambleButtonProps {
    isActive: boolean
    shouldUpdateOpacityWhenInactive?: boolean
}

const GambleButton: React.FC<GambleButtonProps> = ({ isActive, shouldUpdateOpacityWhenInactive }) => {
    const setIsGambleActive = useSpinButtonSectionStore((state) => state.setIsGambleActive)
    const isEQJackpotType = useJackpotStore((state) => state.isEQJackpotType)

    const handleClick = () => {
        const gambleClickedMessage: GambleClickedMessage = { type: GameUIMessageType.GAMBLE_CLICKED }

        window.postMessage(gambleClickedMessage, '*')
        setIsGambleActive(true)
    }

    return (
        <SideButton
            id="gamble-button"
            isActive={isActive}
            onClick={handleClick}
            texture={!isEQJackpotType ? collectButtonTexture : collectButtonTextureEQ}
            shouldUpdateOpacityWhenInactive={shouldUpdateOpacityWhenInactive}
        />
    )
}

export default GambleButton
